// extracted by mini-css-extract-plugin
module.exports = {"balance_wrapper":"_4f720283bf--balance_wrapper--HfWIA","balance":"_4f720283bf--balance--eXScq"};